module.exports = __webpack_public_path__ + "media/images/logo_t8_t-caa71f8ffa26fb7b752cf02f4d4388b0.svg";